export type CompanySize =
  | '1-10'
  | '11-50'
  | '51-200'
  | '201-500'
  | '501-1000'
  | '1000+';

export const COMPANY_SIZES: CompanySize[] = [
  '1-10',
  '11-50',
  '51-200',
  '201-500',
  '501-1000',
  '1000+',
];

export const INDUSTRIES = [
  'Technology',
  'Software',
  'Finance',
  'Healthcare',
  'Education',
  'Manufacturing',
  'Retail',
  'Hospitality',
  'Construction',
  'Energy',
  'Media',
  'Telecommunications',
  'Transportation',
  'Real Estate',
  'Government',
  'Non-Profit',
  'Other',
] as const;

export type Industry = (typeof INDUSTRIES)[number];

export interface Company {
  id: string | number;
  name: string;
  size: CompanySize;
  industry: Industry;
  logo: string;
}

export const EMPTY_COMPANY: Company = {
  id: null,
  name: null,
  size: null,
  industry: null,
  logo: null,
};
